<template>
  <div id="app">
    <!-- Preloader -->
    <div v-if="loading" class="preloader">
      <img src="@/assets/bsclogo.png" alt="Logo" class="preloader-logo" />
    </div>
    <div v-else>
      <AppNavbar />
      <transition name="fade-slide" mode="out-in">
        <router-view />
      </transition>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppNavbar from './components/AppNavbar.vue';
import AppFooter from './components/AppFooter.vue';

const BASE_URL = 'https://app.bhawalsena.club';

export default {
  components: {
    AppNavbar,
    AppFooter,
  },
  data() {
    return {
      loading: true,
      BASE_URL,
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,200..800;1,6..72,200..800&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');

#app {
  font-family: 'Nunito Sans', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  font-family: 'Newsreader', serif;
}

/* @import url('https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400;500;600;700&display=swap');

* {
  font-family: 'Jost', sans-serif;
} */

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* White background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.preloader-logo {
  width: 100px;
  height: auto;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Fade-slide transition styles */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.container {
  max-width: 1200px !important;
}
</style>
